import React, { useMemo, useRef, useState } from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { Grid, styled } from '@mui/material'

import { ProductCarouselContext, ProductCarouselContextType } from './ProductCarouselContext'

export type ProductCarouselContainerProps = {
  children: React.ReactNode;
}

export const ProductCarouselContainer: React.FC<ProductCarouselContainerProps> = ({ children, ...props }) => {
  const flickityRef = useRef(null)
  const thumblistRef = useRef(null)
  const [isFlickityActive, setFlickityActive] = useState(false)

  const carouselContext: ProductCarouselContextType = useMemo(() => ({
    flickityRef,
    thumblistRef,
    isFlickityActive,
    setFlickityActive,
  }), [flickityRef, isFlickityActive])

  return (
    <StyledGrid container direction="row" alignItems="flex-start" justifyContent="flex-start" {...props}>
      <ProductCarouselContext.Provider value={carouselContext}>
        {children}
      </ProductCarouselContext.Provider>
    </StyledGrid>
  )
}

export const StyledGrid = styled(Grid)`
  position: relative;
  width: 100%;
  overflow: hidden;
  gap: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    gap: ${pxToRem(8)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    overflow-y: hidden;
    overflow-x: visible;
    gap: ${pxToRem(16)};
  }
`